import { render } from "./ProductListRow.vue?vue&type=template&id=9d63aec8&ts=true"
import script from "./ProductListRow.vue?vue&type=script&lang=ts"
export * from "./ProductListRow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__